<div class="single-candidate-widget">
  <h3>Reporting to: </h3>
  <b>{{vacancy.reportTo}}</b>
</div>
<div class="single-candidate-widget">
  <h3>job Description:</h3>
  <div [innerHTML]="vacancy.jobDescription"></div>
</div>
<div class="single-candidate-widget job-required">
  <h3>Duties And Responsibilities:</h3>
  <div [innerHTML]="vacancy.dutiesAndResponsibilities"></div>
</div>
<div class="single-candidate-widget job-required">
  <h3>Qualification and Experience:</h3>
  <div [innerHTML]="vacancy.qualifications"></div>
</div>
